import { c as _c } from "react/compiler-runtime";
import { alpha, Box, useTheme } from "@mui/material";
import React from "react";
import type { ArrayData, ArrayDataState, ArrayItemData } from "#/entities/dataStructures/array/model/arraySlice";
import { MatrixRow } from "#/entities/dataStructures/matrix/ui/MatrixRow";
type MatrixStructureViewProps = {
  data: ArrayData;
  arrayState: ArrayDataState;
};
export const MatrixStructureView: React.FC<MatrixStructureViewProps> = t0 => {
  const $ = _c(60);
  const {
    data,
    arrayState
  } = t0;
  const theme = useTheme();
  let t1;
  if ($[0] !== theme.palette.primary.light) {
    t1 = alpha(theme.palette.primary.light, 0.3);
    $[0] = theme.palette.primary.light;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const borderColor = `1px solid ${t1}`;
  const lastNode = data.nodes.entities[String(data.nodes.ids.at(-1))];
  const lastIndex = lastNode?.index ?? 0;
  let T0;
  let T1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[2] !== arrayState || $[3] !== borderColor || $[4] !== data.colHeaders || $[5] !== data.colorMap || $[6] !== data.nodes.entities || $[7] !== data.nodes.ids || $[8] !== data.rowHeaders || $[9] !== lastIndex || $[10] !== theme.palette.action.active || $[11] !== theme.palette.primary.light || $[12] !== theme.palette.text.secondary) {
    const dataArray = data.nodes.ids.map(id => data.nodes.entities[id]);
    const items = new Array(lastIndex + 1);
    dataArray.forEach(node => {
      if (node) {
        items[node.index] = node;
      }
    });
    T1 = Box;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = {
        overflow: "hidden"
      };
      $[20] = t6;
    } else {
      t6 = $[20];
    }
    T0 = Box;
    t3 = "table";
    const t7 = theme.palette.text.secondary;
    let t8;
    if ($[21] !== theme.palette.action.active) {
      t8 = alpha(theme.palette.action.active, 0.01);
      $[21] = theme.palette.action.active;
      $[22] = t8;
    } else {
      t8 = $[22];
    }
    let t9;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = {
        borderRightWidth: 2
      };
      $[23] = t9;
    } else {
      t9 = $[23];
    }
    let t10;
    if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
      t10 = {
        borderBottomWidth: 2,
        "&:first-of-type": {
          borderRightWidth: 2
        }
      };
      $[24] = t10;
    } else {
      t10 = $[24];
    }
    let t11;
    if ($[25] !== borderColor || $[26] !== t8 || $[27] !== theme.palette.text.secondary) {
      t11 = {
        padding: 1,
        textAlign: "center",
        borderBottom: borderColor,
        borderRight: borderColor,
        fontWeight: "light",
        fontSize: "12px",
        lineHeight: "12px",
        color: t7,
        backgroundColor: t8,
        "&[scope='row']": t9,
        "&[scope='col']": t10
      };
      $[25] = borderColor;
      $[26] = t8;
      $[27] = theme.palette.text.secondary;
      $[28] = t11;
    } else {
      t11 = $[28];
    }
    let t12;
    if ($[29] !== theme.palette.primary.light) {
      t12 = alpha(theme.palette.primary.light, 0.032);
      $[29] = theme.palette.primary.light;
      $[30] = t12;
    } else {
      t12 = $[30];
    }
    let t13;
    if ($[31] !== t12) {
      t13 = {
        content: "\"\"",
        position: "absolute",
        top: "-5000px",
        left: 0,
        width: "100%",
        height: "10000px",
        backgroundColor: t12
      };
      $[31] = t12;
      $[32] = t13;
    } else {
      t13 = $[32];
    }
    let t14;
    if ($[33] !== borderColor || $[34] !== t13) {
      t14 = {
        position: "relative",
        padding: 0,
        border: borderColor,
        "&:hover::after": t13
      };
      $[33] = borderColor;
      $[34] = t13;
      $[35] = t14;
    } else {
      t14 = $[35];
    }
    if ($[36] !== borderColor || $[37] !== t11 || $[38] !== t14) {
      t4 = {
        width: "fit-content",
        borderCollapse: "collapse",
        borderSpacing: 0,
        border: borderColor,
        borderRadius: "4px",
        boxSizing: "border-box",
        th: t11,
        td: t14
      };
      $[36] = borderColor;
      $[37] = t11;
      $[38] = t14;
      $[39] = t4;
    } else {
      t4 = $[39];
    }
    let t15;
    if ($[40] !== data.colHeaders) {
      t15 = data.colHeaders ? <><th scope="col" />{data.colHeaders.map(_temp)}</> : null;
      $[40] = data.colHeaders;
      $[41] = t15;
    } else {
      t15 = $[41];
    }
    if ($[42] !== t15) {
      t5 = <thead><tr>{t15}</tr></thead>;
      $[42] = t15;
      $[43] = t5;
    } else {
      t5 = $[43];
    }
    let t16;
    if ($[44] !== arrayState || $[45] !== data.colorMap || $[46] !== data.rowHeaders) {
      t16 = (node_0, index_0) => {
        if (!node_0) {
          return null;
        }
        const name = node_0.childName ?? "";
        const nodeData = arrayState[name];
        const header = data.rowHeaders?.[node_0.index];
        if (nodeData) {
          return <MatrixRow key={name} header={header} data={nodeData} parentColorMap={data.colorMap} />;
        }
        return <Box key={index_0} component="tr" height={43}>{header ? <th scope="row">{header}</th> : null}</Box>;
      };
      $[44] = arrayState;
      $[45] = data.colorMap;
      $[46] = data.rowHeaders;
      $[47] = t16;
    } else {
      t16 = $[47];
    }
    t2 = items.map(t16);
    $[2] = arrayState;
    $[3] = borderColor;
    $[4] = data.colHeaders;
    $[5] = data.colorMap;
    $[6] = data.nodes.entities;
    $[7] = data.nodes.ids;
    $[8] = data.rowHeaders;
    $[9] = lastIndex;
    $[10] = theme.palette.action.active;
    $[11] = theme.palette.primary.light;
    $[12] = theme.palette.text.secondary;
    $[13] = T0;
    $[14] = T1;
    $[15] = t2;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
  } else {
    T0 = $[13];
    T1 = $[14];
    t2 = $[15];
    t3 = $[16];
    t4 = $[17];
    t5 = $[18];
    t6 = $[19];
  }
  let t7;
  if ($[48] !== t2) {
    t7 = <tbody>{t2}</tbody>;
    $[48] = t2;
    $[49] = t7;
  } else {
    t7 = $[49];
  }
  let t8;
  if ($[50] !== T0 || $[51] !== t3 || $[52] !== t4 || $[53] !== t5 || $[54] !== t7) {
    t8 = <T0 component={t3} sx={t4}>{t5}{t7}</T0>;
    $[50] = T0;
    $[51] = t3;
    $[52] = t4;
    $[53] = t5;
    $[54] = t7;
    $[55] = t8;
  } else {
    t8 = $[55];
  }
  let t9;
  if ($[56] !== T1 || $[57] !== t6 || $[58] !== t8) {
    t9 = <T1 sx={t6}>{t8}</T1>;
    $[56] = T1;
    $[57] = t6;
    $[58] = t8;
    $[59] = t9;
  } else {
    t9 = $[59];
  }
  return t9;
};
function _temp(value, index) {
  return <th key={index} scope="col">{value}</th>;
}